import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import NextArrow from './NextArrow';
import PrevArrow from './PrevArrow';
import { Link } from '../../../env';
const Tutorials = () => {
    const Tutorials = [
        {
            label: 'Introduction of software and tools',
            downloadLink: `${Link}/assets/Movies/1.Introductionofsoftwareandtools.mp4`,
            img: `${Link}/assets/TutorialsImage/معرفی-ابزارا-everglow.jpg`,
            parspackHost: 'https://c695764.parspack.net/c695764/IRSystem_Software/videoes/Farsi/1-%20%D9%85%D8%B9%D8%B1%D9%81%DB%8C%20%D9%86%D8%B1%D9%85%20%D8%A7%D9%81%D8%B2%D8%A7%D8%B1%20%D9%88%20%D8%A7%D8%A8%D8%B2%D8%A7%D8%B1%D9%87%D8%A7.mp4',
        },
        {
            label: 'Engine Simolator',
            downloadLink: `${Link}/assets/Movies/simolator.mp4`,
            img: `${Link}/assets/TutorialsImage/سیمیلاتور-everglow.jpg`,
            parspackHost: 'http://c695764.parspack.net/c695764/IRSystem_Software/videoes/Farsi/simolator.mp4',
        },
        {
            label: 'Editing and tuning tables',
            downloadLink: `${Link}/assets/Movies/2.Editingandtuningtables.mp4`,
            img: `${Link}/assets/TutorialsImage/ویرایش-و-تیونینگ-everglow.jpg`,
            parspackHost: 'http://c695764.parspack.net/c695764/IRSystem_Software/videoes/Farsi/2%20-%20%D9%88%DB%8C%D8%B1%D8%A7%DB%8C%D8%B4%20%D9%88%20%D8%AA%DB%8C%D9%88%D9%86%DB%8C%D9%86%DA%AF%20%D8%AC%D8%AF%D8%A7%D9%88%D9%84.mp4',

        },
        {
            label: 'Tabulation and introduction of ECU',
            downloadLink: `${Link}/assets/Movies/3.TabulationandintroductionofIsio.mp4`,
            img: `${Link}/assets/TutorialsImage/معرفی-ایسیو-و-ساخت-جداول-شخصی-everglow.jpg`,
            parspackHost: 'http://c695764.parspack.net/c695764/IRSystem_Software/videoes/Farsi/3%20-%20%D8%AC%D8%AF%D9%88%D9%84%20%D8%B3%D8%A7%D8%B2%DB%8C%20%D9%88%20%D9%85%D8%B9%D8%B1%D9%81%DB%8C%20%D8%A7%DB%8C%D8%B3%DB%8C%D9%88.mp4',

        },
        {
            label: 'Comparison of dumps',
            downloadLink: `${Link}/assets/Movies/4.Comparisonofdumps.mp4`,
            img: `${Link}/assets/TutorialsImage/مقاسیه-دامپها-1.bmp`,
            parspackHost: 'http://c695764.parspack.net/c695764/IRSystem_Software/videoes/Farsi/4%20-%20%D9%85%D9%82%D8%A7%DB%8C%D8%B3%D9%87%20%D8%AF%D8%A7%D9%85%D9%BE%D9%87%D8%A7.mp4',

        },
        {
            label: 'Planning',
            downloadLink: `${Link}/assets/Movies/5.Planning.mp4`,
            img: `${Link}/assets/TutorialsImage/برنامه-ریزی-پیشرفته-everglow.jpg`,
            parspackHost: 'http://c695764.parspack.net/c695764/IRSystem_Software/videoes/Farsi/5%20-%20%D8%A8%D8%B1%D9%86%D8%A7%D9%85%D9%87%20%D8%B1%DB%8C%D8%B2%DB%8C.mp4',

        },
        {
            label: 'Hex Editor',
            downloadLink: `${Link}/assets/Movies/6.HexEditor.mp4`,
            img: `${Link}/assets/TutorialsImage/هگز-ادیتور-پیشرفته-everglow-1.jpg`,
            parspackHost: 'http://c695764.parspack.net/c695764/IRSystem_Software/videoes/Farsi/6%20-%20%D9%87%DA%AF%D8%B2%20%D8%A7%D8%AF%DB%8C%D8%AA%D9%88%D8%B1.mp4',

        },
        {
            label: 'Loading Winolse packages',
            downloadLink: `${Link}/assets/Movies/7.LoadingWinolsepackages.mp4`,
            img: `${Link}/assets/TutorialsImage/بارگزاری-پک-های-وین-اولز-1-everglow.jpg`,
            parspackHost: 'http://c695764.parspack.net/c695764/IRSystem_Software/videoes/Farsi/7%20-%20%D8%A8%D8%A7%D8%B1%DA%AF%D8%B2%D8%A7%D8%B1%DB%8C%20%D9%BE%DA%A9%D9%87%D8%A7%DB%8C%20%D9%88%DB%8C%D9%86%20%D8%A7%D9%88%D9%84%D8%B2.mp4',

        },
        {
            label: 'Automatic Ramp',
            downloadLink: `${Link}/assets/Movies/8.AutomaticRamp.mp4`,
            img: `${Link}/assets/TutorialsImage/ریمپ-اتوماتیک-everglow.jpg`,
            parspackHost: 'http://c695764.parspack.net/c695764/IRSystem_Software/videoes/Farsi/8%20-%20%D8%B1%DB%8C%D9%85%D9%BE%20%D8%A7%D8%AA%D9%88%D9%85%D8%A7%D8%AA%DB%8C%DA%A9.mp4',

        },
        {
            label: 'How to use gauge.mp4',
            downloadLink: `${Link}/assets/Movies/9.Howtousegauge.mp4`,
            img: `${Link}/assets/TutorialsImage/gauge.bmp`,
            parspackHost: 'http://c695764.parspack.net/c695764/IRSystem_Software/videoes/Farsi/%D9%86%D8%AD%D9%88%D9%87%20%DA%A9%D8%A7%D8%B1%D8%A8%D8%B1%D8%AF%20%DA%AF%DB%8C%D8%AC.mp4',

        },
        {
            label: 'How to copy and paste on the table',
            downloadLink: `${Link}/assets/Movies/10.Howtocopyandpasteonthetable.mp4`,
            img: `${Link}/assets/TutorialsImage/copypaste.bmp`,
            parspackHost: 'http://c695764.parspack.net/c695764/IRSystem_Software/videoes/Farsi/%D9%86%D8%AD%D9%88%D9%87%20%DA%A9%D9%BE%DB%8C%20%D9%88%20%D9%BE%DB%8C%D8%B3%D8%AA%20%D8%AF%D8%B1%20%D8%B1%D9%88%DB%8C%20%D8%AC%D8%AF%D9%88%D9%84.mp4',

        },
        {
            label: 'Advanced editing of tables',
            downloadLink: `${Link}/assets/Movies/11.Advancededitingoftables.mp4`,
            img: `${Link}/assets/TutorialsImage/ویرایش حرفه ای جداول advance edit-everglow.jpg`,
            parspackHost: 'http://c695764.parspack.net/c695764/IRSystem_Software/videoes/Farsi/%D9%88%DB%8C%D8%B1%D8%A7%DB%8C%D8%B4%20%D9%BE%DB%8C%D8%B4%D8%B1%D9%81%D8%AA%D9%87%20%D8%AC%D8%AF%D8%A7%D9%88%D9%84.mp4',

        },
        {
            label: 'Advanced use of hex editor',
            downloadLink: `${Link}/assets/Movies/12.Advanceduseofhexeditor.mp4`,
            img: `${Link}/assets/TutorialsImage/هگز-ادیتور-پیشرفته-everglow-1.jpg`,
            parspackHost: 'http://c695764.parspack.net/c695764/IRSystem_Software/videoes/Farsi/%DA%A9%D8%A7%D8%B1%D8%A8%D8%B1%D8%AF%20%D9%BE%DB%8C%D8%B4%D8%B1%D9%81%D8%AA%D9%87%20%D9%87%DA%AF%D8%B2%20%D8%A7%D8%AF%DB%8C%D8%AA%D9%88%D8%B1.mp4',

        },
    ]
    const TitleAndDescription = [
        {
            title: 'How To Make Table ?',
            Description:
                `
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut 
            labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco 
            laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in 
            voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat 
            cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            `
        },
        {
            title: 'How To Make Table ?',
            Description:
                `
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut 
            labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco 
            laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in 
            voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat 
            cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            `
        },
        {
            title: 'How To Make Table ?',
            Description:
                `
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut 
            labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco 
            laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in 
            voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat 
            cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            `
        },
        {
            title: 'How To Make Table ?',
            Description:
                `
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut 
            labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco 
            laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in 
            voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat 
            cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            `
        }
    ]
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 1000,
        arrows: true, // Add this line to remove arrows
        nextArrow: <NextArrow
            class1='text-white absolute top-0 right-0 z-[999999] h-full flex justify-center items-center translate-x-[30px] 2xl:translate-x-[30px] 2xl:translate-y-[0px]'
            class2='w-[30px] cursor-pointer'
            status={false} />,
        prevArrow: <PrevArrow
            class1='text-white absolute z-[99999] top-0 left-0 h-full flex items-center justify-center -translate-x-[30px] 2xl:translate-y-[0px] 2xl:-translate-x-[30px]'
            class2='w-[30px] rotate-90 cursor-pointer'
            status={false} />
    };
    return (
        <div className='w-full flex justify-center mb-[50px] '>
            <div className='container'>
                <div className='w-full mt-[50px]'>
                    <div className='w-full my-10 flex items-center px-10 2xl:px-0'>
                        <div className='w-[40%] xl:w-[42%] border-[1px] border-[rgba(0,0,0,0.4)]'></div>
                        <div className='w-[20%] xl:w-[16%] flex justify-center poppins-medium text-lg'>Tuning Tutorials</div>
                        <div className='w-[40%] xl:w-[42%] border-[1px] border-[rgba(0,0,0,0.4)]'></div>
                    </div>
                    <div className='container 2xl:px-0 xl:px-[40px] px-10'>
                        <Slider {...settings}>
                            {
                                Tutorials.map((item, index) => (
                                    <div key={index} className='w-full px-2 xl:px-3 2xl:px-5'>
                                        <div className='w-full flex border-[1px] border-[rgba(27,38,49,0.5)] rounded-lg'>
                                            <div className='flex-1 relative'>
                                                <img src={item.img} alt='Tutorial' className='w-[300px] h-full rounded-tl-lg rounded-bl-lg' />
                                                <div className='w-full h-full absolute top-0 left-0 z-10 bg-[rgba(0,0,0,0.4)]'></div>
                                                <a href={item.parspackHost}>
                                                    <div className='w-full h-full absolute top-0 left-0 z-50 cursor-pointer flex justify-center items-center'>
                                                        <img src={`${Link}/assets/Icons/player.png`} className='w-[50px] m-1' />
                                                    </div>
                                                </a>
                                            </div>
                                            <div className='flex-1 2xl:flex-[2] h-full rounded-tr-lg rounded-br-lg p-2'>
                                                <div className='w-full py-4 px-2'><h1 className='poppins-medium text-base 2xl:text-2xl text-black'>{item.label}</h1></div>
                                                <div className='poppins-medium text-black px-2 2xl:px-5 text-[14px] 2xl:text-[18px]'>
                                                    {/* {item.Description.slice(0, 100)} . . . */}
                                                </div>
                                                {/* <div className='w-full px-2 2xl:px-5 absolute bottom-5 xl:bottom-12 2xl:bottom-6'>
                                                    <button className='text-sm px-4 hover:bg-slate-700 py-2 rounded-md 2xl:px-[20px] 2xl:py-3 text-white bg-[#1f618d] 2xl:rounded-md poppins-regular 2xl:text-md'>
                                                        Watch
                                                    </button>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </Slider>
                    </div>
                </div>
                {/* <div className='w-full mt-[80px]'>
                    <div className='w-full my-10 flex items-center px-10 2xl:px-0'>
                        <div className='w-[35%] xl:w-[40%] border-[1px] border-[rgba(0,0,0,0.4)]'></div>
                        <div className='w-[30%] xl:w-[20%] flex justify-center poppins-medium text-lg'>ECU Engineering Tutorials</div>
                        <div className='w-[35%] xl:w-[40%] border-[1px] border-[rgba(0,0,0,0.4)]'></div>
                    </div>
                    <div className='container 2xl:px-0 xl:px-[40px] px-10'>
                        <Slider {...settings}>
                            {
                                TitleAndDescription.map((item, index) => (
                                    <div key={index} className='w-full px-2 xl:px-3 2xl:px-5'>
                                        <div className='w-full flex border-[1px] border-[rgba(27,38,49,0.5)] rounded-lg'>
                                            <div className='flex-1'>
                                                <img src={`${Link}assets/Icons/Tuturial1.png`} alt='Tutorial' className='w-full h-full rounded-tl-lg rounded-bl-lg' />
                                            </div>
                                            <div className='flex-1 relative 2xl:flex-[2] h-full rounded-tr-lg rounded-br-lg p-2'>
                                                <div className='w-full py-4 px-2'><h1 className='poppins-medium text-base 2xl:text-2xl text-black'>{item.title}</h1></div>
                                                <div className='poppins-medium text-black px-2 2xl:px-5 text-[14px] 2xl:text-[18px]'>
                                                    {item.Description.slice(0, 100)} . . .
                                                </div>
                                                <div className='w-full absolute -bottom-12 xl:-bottom-20 2xl:-bottom-14 px-2 2xl:px-5'>
                                                    <button className='text-sm px-4 hover:bg-slate-700 py-2 rounded-md 2xl:px-[20px] 2xl:py-3 text-white bg-[#1f618d] 2xl:rounded-md poppins-regular 2xl:text-md'>
                                                        Read More
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </Slider>
                    </div>
                </div> */}
            </div>
        </div>
    );
}

export default Tutorials;